import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'

export default createVuetify({
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#1976d2',
          'primary-darken-1': '#1565c0',
          'primary-lighten-1': '#1e88e5',
          'primary-lighten-5': '#f5f9ff',
          background: '#ffffff',
          surface: '#ffffff',
        },
      },
    },
  },
})
